const NATIONAL_PROMO_POPUP_SESSION_PREFIX = 'nationalPromoPopupClosed:';

const normalizeSignatureValue = (value) =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const getPromotionSignature = (promotionValues = {}) => ({
  line2: normalizeSignatureValue(promotionValues.line2),
});

const getPromotionPopupSessionKey = (promotionValues = {}) => {
  const promotionSignature = JSON.stringify(
    getPromotionSignature(promotionValues),
  );
  let hash = 0;

  for (let index = 0; index < promotionSignature.length; index += 1) {
    hash = (hash << 5) - hash + promotionSignature.charCodeAt(index);
    hash |= 0;
  }

  return NATIONAL_PROMO_POPUP_SESSION_PREFIX + hash;
};

export default getPromotionPopupSessionKey;
